import { render, staticRenderFns } from "./CouponEC.vue?vue&type=template&id=70419a00&"
import script from "./CouponEC.vue?vue&type=script&lang=js&"
export * from "./CouponEC.vue?vue&type=script&lang=js&"
import style0 from "./CouponEC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports